"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var ApplicationStatus_1 = require("./ApplicationStatus");

var PromoApplicationStatus =
/*#__PURE__*/
function (_ApplicationStatus_1$) {
  _inherits(PromoApplicationStatus, _ApplicationStatus_1$);

  /**
   * @param id
   * @param frontendLocked
   */
  function PromoApplicationStatus(id, frontendLocked) {
    var _this;

    _classCallCheck(this, PromoApplicationStatus);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromoApplicationStatus).call(this));
    _this.id = id;
    _this.frontendLocked = frontendLocked;
    return _this;
  }

  return PromoApplicationStatus;
}(ApplicationStatus_1.ApplicationStatus);

exports.PromoApplicationStatus = PromoApplicationStatus;

PromoApplicationStatus.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PromoApplicationStatus.name);
  return {
    id: builder.id('id'),
    frontendLocked: builder.bool('frontendLocked')
  };
}();